import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Button,
  ModalBody,
  Modal,
  Input,
  ModalHeader,
  ModalFooter,
  Table,
  Label,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faEye,
  faDownload,
  faCheck,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import "react-datepicker/dist/react-datepicker.css";
import SidebarList from "./SidebarList";
import { useHistory } from "react-router-dom";
import FolderIcon from "../../assets/img/folder-cfa.svg";
import IncomeIcon from "../../assets/img/income-calc.svg";
import IdLogo from "../../assets/img/id-logo.jpg";
import DownloadIcon from "../../assets/img/download-icon.svg";
import PreviousCalcIcon from "../../assets/img/prev-cal-icon.svg";
import "./incomeAnalyzer.scss";
import { useDispatch, useSelector } from "react-redux";
/*import { getDocumentsByIdIncomeAnalyzer, getDocumentsIncomeAnalyzer } from "../../context/actions/document";*/
import { set_page } from "../../context/actions/general";
import { pagination } from "../../utils/constants";
import { toArrayBuffer } from "../../utils/common";
import Swal from 'sweetalert2';
import {
  getIncomeAnalyzer,
  mergeIncomeAnalyzer,
  resetIncomeAnalyzer,
  getIncomeAnalyzerAllPdf,
  getIncomeAnalyzerCalculationSheet,
  getElasticSearchIncomeAnalyzer,
  getTaxFormsListing,
  getIncomeStatus,
  getIncomeDocList,
  sendIncomeToLoans,
  saveUnableToIncomeAnalyzerJsonData,
  updateCompleteStatus,
  saveQAVerification

} from "../../context/actions/irsIncome";
import NoItem from "./NoItem";
import InternalError from "./InternalError";
import IncomeAnalyzerModal from "./CsvModal/CsvModal";
import { toast } from "react-toastify";
import PushIcon from "../../assets/img/icons/push-icon.svg";
import "react-toastify/dist/ReactToastify.css";
import { toasterConfig } from "../../utils/constants";
import { navigationAction } from "../../context/actions/navigationAction";
import { navigationAction2 } from "../../context/actions/navigationAction2";
import LoaderUI from "../../components/common/loader/index";
import ErrorMessage from "./ErrorMessage";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { Formik, Form } from "formik";
import { fetchMails, getFileDoc, appendDocumentsById } from "../../context/actions/document";
import classnames from "classnames";
import DocumentLog from "./DocumentLog";
import UnableToIncomeAnalyzer from "./UnableToIncomeAnalyzer";
import { getPendingIRSIncomeDetail } from "../../context/actions/irsIncome"
import withReactContent from "sweetalert2-react-content";
const IncomeAnalyzer = () => {
  const MySwal = withReactContent(Swal);
  const history = useHistory();
  const underwriter = useSelector((state) => state?.user?.user?.roles?.permissions?.find(item => item.SLUG === "underwriter")) ? true : false
  const userId = useSelector((state) => state?.user?.user?._id)
  const [sidebarActivePacketIndex, setsidebarActivePacketIndex] =
    useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  let totalRecords = useSelector((state) => state.incomeAnalyzer.totalRecords);
  let incomeAnalyzer = useSelector((state) => state.incomeAnalyzer.records);
  const [page, setPage] = useState(pagination.page);
  const [loader, setLoader] = useState(false);
  let [status, setStatus] = useState(null);
  let [sort, setSort] = useState("createdAt");
  let [order, setOrder] = useState(-1);
  let [sortOrder, setSortOrder] = useState(2);
  let [pdfFileURL, setPdfFileURL] = useState(null);
  const [elasticSearchList, setElasticSearchList] = useState([]);
  let [irsDetail, setIrsDetail] = useState(null);
  console.log('jhasdasgdasd', irsDetail)
  let [isUnableToValidateOpen, setIsUnableToValidateOpen] = useState(false);
  let [disabledUnableToDocumentFields, setDisabledUnableToDocumentFields] =
    useState(false);
  let [noRecords, setNoRecords] = useState(true);
  let [calculationSheetModal, setCalculationSheetModal] = useState(false);
  let [elasticPayload, setElasticPayload] = useState({});
  let [focusSearchFlag, setFocusSearchFlag] = useState(false);
  const [qaActiveLink, setQaActiveLink] = useState(irsDetail?.qc_status ? 1 : irsDetail?.qc_status === false ? 2 : 3);
  const [modalOpen, setModalOpen] = useState(false);
  const [heading, setHeading] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [pendingIrsIncomeLoanNumber, setPendingIrsIncomeLoanNumber] = useState(null);
  const [pendingIrsIncomeDetail, setPendingIrsIncomeDetail] = useState(null);
  let [activeId, setActiveId] = useState(null);
  let [payload, setPayload] = useState({
    page: 1,
    limit: 8,
    sort: "createdAt",
    order: -1,
  });
  const [initValues, setInitValues] = useState({
    error: [],
    otherreason: false,
    note: "",
  });

  useEffect(() => {
    setQaActiveLink(irsDetail?.qc_status ? 1 : irsDetail?.qc_status === false ? 2 : 3)
  }, [irsDetail])
  let [internalError, setInternalError] = useState(false);
  let [taxFormsListing, setTaxFormsListing] = useState([]);
  const [incomeStatus, setIncomeStatus] = useState({});
  const [incomeDocList, setIncomeDocList] = useState({});
  const [modal, setModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("select all");
  const [time, setTime] = useState();
  const [previousTimes, setPreviousTimes] = useState([]);
  const [activeMainIndex, setActiveMainIndex] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeSubIndex, setActiveSubIndex] = useState(0);
  const [msg, setMsg] = useState("");
  const [contacts, setContacts] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [buttonDisable, setButtonDisable] = useState(true);
  const [log, setLog] = useState('');
  const [activeTab, setActiveTab] = useState("form-view");
  const [timer, setTimer] = useState(new Date());
  const [failureReason, setFailureReason] = useState('');

  let permissions = useSelector((state) => state?.user?.user?.roles?.permissions);
  let isQCPerson = permissions?.some((obj) => obj?.SLUG === "quality_control");

  let notify = false;

  useEffect(() => {
    setTimer(new Date());
    setLoader(true);
    dispatch(set_page(1));
    dispatch(resetIncomeAnalyzer());
    dispatch(
      getTaxFormsListing((result) => {
        if (result && result.length) {
          setTaxFormsListing(result);
        }
        // setLoader(false);
      })
    );
    const newPayload = {
      ...payload,
      irsIncomeId: location?.state?.irsIncomeId,
      allowComplete: location?.state?.allowComplete
    };
    location?.state?.irsIncomeId
      ? getIncomeAnalyzerList(newPayload)
      : getIncomeAnalyzerList(payload);
  }, []);

  const getIncomeAnalyzerList = (payload) => {
    setLoader(true);
    setInternalError(false);
    dispatch(
      getIncomeAnalyzer(payload, (result) => {
        setLoader(false);
        console.log("result", result);
        if (result && result?.docs && result?.docs.length) {
          setNoRecords(false);
          if(result?.docs[0].taxpayer_name && result?.docs[0].taxpayer_name.length){
            setActiveId(result?.docs[0].taxpayer_name[0]._id);
            incomeAnalyzerPdf(result?.docs[0].taxpayer_name[0].docs[0]._id);
          }else{
            setActiveId(result?.docs[0]._id);
            getPendingIRSIncome(result?.docs[0]._id)

          }
         
          
          // dispatch(getIncomeStatus(result?.docs[0].taxpayer_name[0]._id, (data)=>{
          // 	setIncomeStatus(data)
          // }))
          // dispatch(getIncomeDocList(result?.docs[0].taxpayer_name[0]._id, (data)=>{
          // 	setIncomeDocList(data)
          // }))
        } else {
          setActiveId(null)
          setNoRecords(true);
          setIncomeDocList({})
          setIncomeStatus({})
        }
      })
    );
  };


  const _saveUnableToIncomeAnalyzerJsonData = (payload) => {
    setLoader(true);
    dispatch(
      saveUnableToIncomeAnalyzerJsonData(activeId, { json: payload, validationCompletionTime: Math.round((new Date() - timer) / 1000),
        ...(Array.isArray(incomeStatus?.status?.reviewNotes) && incomeStatus?.status?.reviewNotes.length !== 0 && { reviewNotes: incomeStatus.status.reviewNotes })
       }, (result) => {
        if (result.success == true) {
          setTimer(new Date())
          setLog("Unable to Calculate Income");
          setTime(result.currentDate);
          setIrsDetail({ ...irsDetail, 'unable_to_calculate_income': true })
        } else {
          setTimer(new Date())
        }
        setLoader(false);
        setIsUnableToValidateOpen(false)
      })
    );
  };


  const getIncomeAnalyzerListWitSelectedId = (payload, moreInfo) => {
    setLoader(true);
    dispatch(
      getIncomeAnalyzer(payload, (result) => {
        setLoader(false);
        console.log("result", result);
        if (result && result?.docs && result?.docs.length) {
          setNoRecords(false);
        
          if(result?.docs[0].taxpayer_name && result?.docs[0].taxpayer_name.length){
            setActiveId(moreInfo?._id);
            incomeAnalyzerPdf(moreInfo?._id);
          }else{
            setActiveId(result?.docs[0]._id);
            getPendingIRSIncome(result?.docs[0]._id)

          }

        } else {


          setActiveId(null)
          setNoRecords(true);
          setIncomeDocList({})
          setIncomeStatus({})
        }
      })
    );
  };

  const handleClick1 = () => {
    setShowModel(true);
  };

  const handleClick = () => {
    setLoader(true);
    dispatch(
      getIncomeAnalyzerCalculationSheet(irsDetail?._id, async (res) => {
        setLoader(false);
        if (res?.calculationSheetBuffer) {
          const buff = Buffer.from(res?.calculationSheetBuffer);
          const file = new Blob([buff], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(file);
          a.download = "getIncomeAnalyzerCalcul.xlsx";
          a.click();
        } else {
          toast.error(
            "An error occurred while generating the income calculation worksheet. Please contact MORi Support at MORiSupport@gettrained.ai for assistance.",
            toasterConfig
          );
        }
      })
    );
  };

  const _pdfDownload = () => {
    let a = document.createElement("a");
    a.href = pdfFileURL;
    a.download = "transcripts.pdf";
    a.click();
  };

  const markAscomplete = () => {
    MySwal.fire({
      title: "Mark as Complete",
      text: "Are you sure you want to Mark this complete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(updateCompleteStatus({
          irsIncomeId: irsDetail._id, validationCompletionTime: Math.round((new Date() - timer) / 1000),
          ...(Array.isArray(incomeStatus?.status?.reviewNotes) && incomeStatus?.status?.reviewNotes.length !== 0 && { reviewNotes: incomeStatus.status.reviewNotes })
        }, (res) => {
          toast.success(
            "Income Analyzer Marked as Completed"
          );
          // if (activeSubIndex < incomeAnalyzer[activeMainIndex]?.taxpayer_name[activeIndex]?.docs?.length - 1) {
          //   // Move to the next doc
          //   // setActiveSubIndex(activeSubIndex + 1);
          //   setActiveId(incomeAnalyzer[activeMainIndex].taxpayer_name[activeIndex].docs[activeSubIndex + 1]?._id);
          //   incomeAnalyzerPdf(incomeAnalyzer[activeMainIndex].taxpayer_name[activeIndex].docs[activeSubIndex + 1]?._id);
          // } else {
          //     // No next doc available
          //     if (activeSubIndex > 0) {
          //       console.log("wsdwererer1")
          //         // Move to the previous doc
          //         setActiveSubIndex(activeSubIndex - 1);
          //         setActiveId(incomeAnalyzer[activeMainIndex].taxpayer_name[activeIndex].docs[activeSubIndex - 1]?._id);
          //         incomeAnalyzerPdf(incomeAnalyzer[activeMainIndex].taxpayer_name[activeIndex].docs[activeSubIndex - 1]?._id);
          //     } else {
          //       console.log("wsdwererer")
          //         // No previous doc available, check taxpayer_name
          //         if (activeIndex < incomeAnalyzer[activeMainIndex]?.taxpayer_name?.length - 1) {
          //           console.log("wsdwererer2")
          //             // Move to the next taxpayer
          //             setActiveIndex(activeIndex + 1);
          //             setActiveSubIndex(0);
          //             setActiveId(incomeAnalyzer[activeMainIndex].taxpayer_name[activeIndex + 1]?.docs[0]?._id);
          //             incomeAnalyzerPdf(incomeAnalyzer[activeMainIndex].taxpayer_name[activeIndex + 1]?.docs[0]?._id);
          //         } else if (activeIndex > 0) {
          //           console.log("wsdwererer3")
          //             // Move to the previous taxpayer
          //             setActiveIndex(activeIndex - 1);
          //             setActiveSubIndex(0);
          //             setActiveId(incomeAnalyzer[activeMainIndex].taxpayer_name[activeIndex - 1]?.docs[0]?._id);
          //             incomeAnalyzerPdf(incomeAnalyzer[activeMainIndex].taxpayer_name[activeIndex - 1]?.docs[0]?._id);
          //         } else {
          //           console.log("wsdwererer6")
          //             // No previous taxpayer available, check incomeAnalyzer
          //             if (activeMainIndex < incomeAnalyzer.length - 1) {
          //               console.log("wsdwererer4")
          //                 // Move to the next main index
          //                 setActiveMainIndex(activeMainIndex + 1);
          //                 setActiveIndex(0);
          //                 setActiveSubIndex(0);
          //                 setActiveId(incomeAnalyzer[activeMainIndex + 1].taxpayer_name[0]?.docs[0]?._id);
          //                 incomeAnalyzerPdf(incomeAnalyzer[activeMainIndex + 1].taxpayer_name[0]?.docs[0]?._id);
          //             } else if (activeMainIndex > 0) {
          //               console.log("wsdwererer5")
          //                 // Move to the previous main index
          //                 setActiveMainIndex(activeMainIndex - 1);
          //                 setActiveIndex(0);
          //                 setActiveSubIndex(0);
          //                 setActiveId(incomeAnalyzer[activeMainIndex - 1].taxpayer_name[0]?.docs[0]?._id);
          //                 incomeAnalyzerPdf(incomeAnalyzer[activeMainIndex - 1].taxpayer_name[0]?.docs[0]?._id);
          //             } else{
          //               setNoRecords(true)
          //             }
          //         }
          //     }
          // }
          setTimer(new Date())
          // dispatch({
          //   type: "REMOVE_INCOME_ANALYZER_ITEM",
          //   data: { activeMainIndex, activeIndex, activeSubIndex }
          // });
        }))

      }
    })


  }

  const showModal = () => {
    setShowModel(true);
  };
  const closeModal = () => {
    setShowModel(false);
  };

  const _advanceFilter = (val) => {
    console.log('sdasdada')
    setPage(1);
    setStatus(val);
    if (val == "Review") {
      setElasticPayload({ ...elasticPayload, reviewRequired: true, calcReady: "" });
      setPayload({ ...payload, page: 1, limit: 8, reviewRequired: true, calcReady: "" });
      getIncomeAnalyzerList({ ...payload, page: 1, limit: 8, reviewRequired: true, calcReady: "" });
    } else {
      setElasticPayload({ ...elasticPayload, calcReady: val, reviewRequired: null });
      setPayload({ ...payload, page: 1, limit: 8, calcReady: val, reviewRequired: null });
      getIncomeAnalyzerList({ ...payload, page: 1, limit: 8, calcReady: val, reviewRequired: null });
    }

  };

  const __advanceFilter = (sortBy, order, sortOrder) => {
    setSort(sortBy);
    setOrder(order);
    setSortOrder(sortOrder);
    setPage(1);
    setPayload({ ...payload, page: 1, limit: 8, sort: sortBy, order: order });
    getIncomeAnalyzerList({
      ...payload,
      page: 1,
      limit: 8,
      sort: sortBy,
      order: order,
    });
  };

  const _resetFilter = () => {
    setElasticPayload({});
    setFocusSearchFlag(false);
    setSort("createdAt");
    setOrder(-1);
    setStatus(null);
    setPage(1);
    setPayload({
      ...payload,
      page: 1,
      limit: 8,
      sort: "createdAt",
      order: -1,
      calcReady: "",
      filter: null,
      reviewRequired: null
    });
    getIncomeAnalyzerList({
      ...payload,
      page: 1,
      limit: 8,
      sort: "createdAt",
      order: -1,
      calcReady: "",
      reviewRequired: null,
      filter: null,
    });
  };

  const _handlePageChange = (page) => {
    setPage(page);
    setPayload({ ...payload, page: page });
    setLoader(true);
    dispatch(
      mergeIncomeAnalyzer({ ...payload, page: page }, (result) => {
        setLoader(false);
      })
    );
  };

  const _incomeAnalyzerSearch = (val, moreInfo) => {
    setPage(1);
    setPayload({
      ...payload,
      page: 1,
      fields: "loan_number,taxpayer_name",
      filter: val,
    });
    setLoader(true);
    if (moreInfo) {
      getIncomeAnalyzerListWitSelectedId(
        {
          ...payload,
          page: 1,
          fields: "loan_number,taxpayer_name",
          filter: val,
        },
        moreInfo
      );
    } else {
      getIncomeAnalyzerList({
        ...payload,
        page: 1,
        fields: "loan_number,taxpayer_name",
        filter: val,
      });
    }
  };

  const incomeAnalyzerPdf = (irsIncomeId, mainIndex, index, subIndex) => {
    if (mainIndex != undefined && index != undefined && subIndex != undefined) {
      setActiveMainIndex(mainIndex)
      setActiveIndex(index)
      setActiveSubIndex(subIndex)
    }
    setIncomeStatus({});
    setIncomeDocList({});
    setLoader(true);
    setIrsDetail(null);
    setActiveId(irsIncomeId);
    setTime();
    setLog('');
    setInternalError(false);
    setActiveTab("form-view");
    setPendingIrsIncomeLoanNumber(null);
    setPendingIrsIncomeDetail(null);
    dispatch(
      getIncomeAnalyzerAllPdf(irsIncomeId, async (res) => {

        console.log('resss',res);
        if (res?.result) {
          setIrsDetail(res?.result);
          const uniqueIdentifier = new Date().getTime();
          history.push(`?timestamp=${uniqueIdentifier}`);
          setTimer(new Date())
        }
        if (res?.log) {
          console.log('res?.log', res?.log)
          setLog(res?.log?.logDetail);
          setTime(res?.log?.time);
          setPreviousTimes(res?.log);
        }
        if (res?.blobAllIncomeAnalyzerPdf) {
          const buff = Buffer.from(res?.blobAllIncomeAnalyzerPdf);
          const file = new Blob([buff], { type: "application/pdf" });
          setPdfFileURL(window.URL.createObjectURL(file));
        } else {
          setPdfFileURL(null);
          //toast.error('Some Internal Ml Error, Please contact admin.', toasterConfig);
          setInternalError(true);
        }

        dispatch(
          getIncomeDocList(irsIncomeId, (docdata) => {
            setIncomeDocList(docdata);
            dispatch(
              getIncomeStatus(irsIncomeId, (data) => {
              
                setIncomeStatus(data);
                if(data?.update_unable_to_calculate_income == false){
                  
                  setIrsDetail({ ...res?.result, 'unable_to_calculate_income': false });
                }
                setLoader(false);
              })
            );
          })
        );
      })
    );
  };


  const getPendingIRSIncome = (loan_nmber) => {

      setIncomeStatus({});
      setIncomeDocList({});
      setLoader(true);
      setIrsDetail(null);
      setActiveId(null);
      setLog('');
      setInternalError(false);
      setActiveTab("form-view");
      setPendingIrsIncomeLoanNumber(loan_nmber);
      setPdfFileURL(null);
      setPendingIrsIncomeDetail(null);
      dispatch(
        getPendingIRSIncomeDetail(loan_nmber, async (res) => {
          setLoader(false);
          setTimer(new Date());
  
          if (res?.pendingIrsIncomeDetail) {
            setPendingIrsIncomeDetail(res?.pendingIrsIncomeDetail)
          }
          if (res?.blobAllIncomeAnalyzerPdf) {
            const buff = Buffer.from(res?.blobAllIncomeAnalyzerPdf);
            const file = new Blob([buff], { type: "application/pdf" });
            setPdfFileURL(window.URL.createObjectURL(file));
          } else {
            setPdfFileURL(null);
            setInternalError(true);
          }
  
        })
      );

   
  };

  /**
   * @description funnction call to search value by elasticsearc
   * @param {string} param search value
   */

  const _elasticSearch = async (val) => {
    if (val.trim()) {
      elasticPayload = { ...elasticPayload, name: val };
      setElasticPayload(elasticPayload);
      await dispatch(
        getElasticSearchIncomeAnalyzer(elasticPayload, (result) => {
          let results = result?.hits?.hits.filter((item) => {
            return item;
          });
          setElasticSearchList(results);

          setFocusSearchFlag(true);
        })
      );
    } else {
      setElasticSearchList([]);
    }
  };

  const toggleModal = () => {
    if (!modal) {
      setContacts([]);
      dispatch(
        fetchMails({ loanNumber: irsDetail?.loan_number }, (res) => {
          if (res.errors) {
            setMsg(res.errors.msg);
          } else if (res.contacts) {
            setContacts(res.contacts);
          } else {
            setContacts([]);
          }
        })
      );
    }
    setModal(!modal);
  };

  const handleRadioClick = (option) => {
    setSelectedOption(option);
  };

  const sendLoans = (params, status) => {
    const resultArray = contacts
      .filter((contact, index) => {
        const notifyKey = `notify_${index}`;
        return params[notifyKey] === true;
      })
      .map((contact) => ({ email: contact.email }));


      console.log('irsDetail',incomeStatus,irsDetail)

    let data = {
      loanNumber: irsDetail?.loan_number,
      incomeSource : incomeStatus?.incomeSource ? incomeStatus?.incomeSource : '',
      contacts: resultArray,
      validationCompletionTime: Math.round((new Date() - timer) / 1000),
      ...(Array.isArray(incomeStatus?.status?.reviewNotes) && incomeStatus?.status?.reviewNotes.length !== 0 && { reviewNotes: incomeStatus.status.reviewNotes })
    };
    if (resultArray?.length == 0) {
      toast.error("Please Select Atleast one loan contact");
      toggleModal();
    } else {

      console.log('data--->',data);
      dispatch(
        sendIncomeToLoans(activeId, data, (res) => {
          if (res?.success == true) {
            setTimer(new Date())
            setTime(res.currentDate);
            setIrsDetail({ ...irsDetail, 'sent_to_los_status': 'Completed' })
            setLog("Sent Income Worksheet to Loan Contacts");
            toast.success(
              "Income Analyzer Worksheet successfully sent to the loan contact(s)"
            );
          } else {
            setTimer(new Date())
            toast.error(
              "Income Analyzer Worksheet not successfully sent to the loan contact(s)"
            );
          }
        })
      );
      toggleModal();
    }
  };

  const focusSearch = () => { };
  const navigationState = useSelector((state) => state.navigationReducer.isOn);
  const editorVisible = useSelector((state) => state.navigationReducer2.isOn2);

  const navigationHandler = () => {
    dispatch(navigationAction(!navigationState));
  };
  const sidebarEditorHandler = () => {
    dispatch(navigationAction2(!editorVisible));
  };
  const overClickHandler = () => {
    dispatch(navigationAction(false));
    dispatch(navigationAction2(false));
  };

  // Submit the form to ML Api
  const submitForm = () => {
    console.log("Submitted Form");
  };

  const toggle_tabs = (option) => {
    setActiveTab(option);
    if (option == "form-view") {
      if (activeId) {
        incomeAnalyzerPdf(activeId);
      }

    }
  };

  const toggleModal2 = () => {
    setModalOpen(!modalOpen);
  };


  const qaStatus = (tab) => {
    setQaActiveLink(tab)
    toggleModal2();
  };

  const handleInputChange = (event) => {
    setFailureReason(event.target.value);
  };

  const QAVerification = (status, message) => {
    if (status == true) {
      dispatch(saveQAVerification({ status: true, docId: irsDetail?._id, validationCompletionTime: Math.round((new Date() - timer) / 1000) }, (res) => {
        setTimer(new Date())
      }))
    } else if (status == false) {
      dispatch(saveQAVerification({ status: false, reason: message, docId: irsDetail?._id, validationCompletionTime: Math.round((new Date() - timer) / 1000) }, (res) => {
        setTimer(new Date())
      }))
    }
  }

  const handleSubmit = () => {
    if (qaActiveLink == 1) {
      QAVerification(true);
      toggleModal2();
    } else {
      if (failureReason == "" || failureReason == null) {
        toast.error('Enter a valid reason.', toasterConfig);
      } else {
        QAVerification(false, failureReason);
        toggleModal2();
      }
    }
  };

  const groupMessagesByCategory = (data) => {
    return data.reduce((acc, item) => {
      const category = item.category || ''; // Use 'withoutcategory' for items with no category
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(item.detailedErrorMessage);
      return acc;
    }, {});
  };

  const openDocumentDirectlyInNewTab = (docId) => {
    if (!docId) return;
  
    dispatch(
      getFileDoc({ docId: docId.toString() }, (result) => {
        if (result && Object.keys(result).length) {
          dispatch({ type: "INCOME_DOCUMENTS_REDIRECT", data: [result] });
  
          setTimeout(() => {
            const newTab = window.open("/documentDetail", "_blank");
            if (!newTab) {
              toast.error("Popup blocked! Please allow popups for this site.");
            }
          }, 100);
        } else {
          toast.success("The file is already archived", toasterConfig);
          window.open("/documents", "_blank");
        }
      })
    );
  };
  
  
  
  

  let groupedMessages = incomeStatus?.unmetDependencies && incomeStatus?.unmetDependencies.length ?   groupMessagesByCategory(incomeStatus?.unmetDependencies.sort((a, b) => {
  // If 'a' doesn't have category, it should come first
  const hasCategoryA = a.hasOwnProperty('category');
  const hasCategoryB = b.hasOwnProperty('category');
  // Objects without category should come first
  if (!hasCategoryA && hasCategoryB) return -1;
  if (hasCategoryA && !hasCategoryB) return 1;
  return 0;  // If both have or don't have the 'category' key, keep their order
})) : {};




  return (


    <>
      <IncomeAnalyzerModal
        showModel={showModel}
        closeModal={closeModal}
        heading={heading}
      />
      <div className="page-header border-0 income-analyzer-header d-flex align-items-center responsive-menu-btn desktop-page-header">
        <h2>Income Analyzer</h2>
        <div className="right-col ms-auto">
          <Button
            color="link"
            className="toggle-btn"
            onClick={navigationHandler}
          >
            <FontAwesomeIcon icon={faBars} />
          </Button>
          <Button
            color="link"
            className="toggle-btn"
            onClick={sidebarEditorHandler}
          >
            <FontAwesomeIcon icon={faEye} />
          </Button>
        </div>
      </div>
      <div className="documents-wrapper frequency-wrapper d-flex flex-fill overflow-auto position-relative">
        <div
          className={`sidebarListOverlay ${navigationState || editorVisible ? "active" : ""
            }`}
          onClick={overClickHandler}
        ></div>
        <div
          className={`
				left-col d-flex flex-column overflow-auto sidebar-list-col 
				${navigationState ? "active" : ""} 
				`}
        >
          <div className="sidebar-title">
            <h2>Income Analyzer</h2>
          </div>
          {incomeAnalyzer && (
            <SidebarList
              activeId={activeId}
              _resetFilter={_resetFilter}
              //sidebarLoading={sidebarLoading}
              // sidebarLoadingLabel={sidebarLoadingLabel}
              //  sidbarLoadingButton={sidbarLoadingButton}
              page={page}
              handlePageChange={(page) => _handlePageChange(page)}
              _filter={_advanceFilter}
              __filter={(sortBy, order, sortOrder) =>
                __advanceFilter(sortBy, order, sortOrder)
              }
              search={(val, moreInfo) => _incomeAnalyzerSearch(val, moreInfo)}
              //menu="document" _innerLodder={innerLoader}
              handleElasticSearch={(val) => _elasticSearch(val)}
              elasticSearchList={elasticSearchList}
              focusSearchFlag={focusSearchFlag}
              _focusSearch={(val) => focusSearch(val)}
              // filter={filter}
              _sidebarActivePacketIndex={sidebarActivePacketIndex}
              list={incomeAnalyzer}
              totalRecords={totalRecords}
              status={status}
              sort={sort}
              order={order}
              sortOrder={sortOrder}
              incomeAnalyzerPdf={(irsIncomeId, mainIndex, index, subIndex) =>
                incomeAnalyzerPdf(irsIncomeId, mainIndex, index, subIndex)
              }
              getPendingIRSIncome={(loan_nmber) =>
                getPendingIRSIncome(loan_nmber)}
              pendingIrsIncomeLoanNumber={pendingIrsIncomeLoanNumber}
            />
          )}
        </div>

        <div className="mid-col d-flex flex-column flex-fill overflow-auto">
          <div className="income-detail-wrap d-flex  w-100 flex-wrap ">
            <div className="income-doc-wrap income-box flex-fill  ">
              <h3 className="d-block text-center">Income Documents</h3>
              <div className="income-icon-wrap d-flex">
                <Col xs="6">
                  <div className="cfa-cell">
                    <div className="icon-wrap d-flex justify-content-center">
                      <span className="icon-btn">
                        <svg
                          width="22"
                          height="21"
                          viewBox="0 0 22 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0 18.7768V2.08832C0.0648978 1.49233 0.30649 0.947957 0.67735 0.562039C1.04821 0.17612 1.52154 -0.0235454 2.00462 0.0022152H8.9882C9.07051 -0.000987371 9.15234 0.0194103 9.22731 0.0617984C9.30228 0.104186 9.36842 0.16747 9.4206 0.246715L10.9667 2.54465C11.0045 2.61668 11.0575 2.67447 11.1198 2.71181C11.1822 2.74914 11.2516 2.76457 11.3205 2.75647H19.8631C20.079 2.75063 20.2947 2.77803 20.5051 2.83799C20.9424 2.96907 21.3299 3.28392 21.6021 3.72935C21.8743 4.17477 22.0144 4.72345 21.9988 5.28259C21.9988 9.68287 21.9988 14.0832 21.9988 18.4834C22.0008 18.8665 21.9337 19.2452 21.8023 19.5917C21.6395 20.0395 21.3698 20.4141 21.03 20.6648C20.6901 20.9156 20.2965 21.0302 19.9025 20.9932H1.79502C1.54077 20.9611 1.29414 20.8669 1.06929 20.7159C0.844428 20.5648 0.645783 20.36 0.484781 20.1132C0.234359 19.7263 0.0674994 19.2663 0 18.7768Z"
                            fill="#848484"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="icon-wrap-title d-flex justify-content-center text-center">
                      CFA, Inc Docs &<br /> Transcripts
                    </div>
                  </div>
                </Col>
                <Col xs="6">
                  <div
                    className={`${incomeStatus?.status?.calcReady == true
                      ? "active-cell"
                      : ""
                      } income-calc-cell`}
                  >
                    <div className="icon-wrap d-flex justify-content-center">
                      <span
                        className={`icon-btn ${incomeStatus?.status?.calcReady == true
                          ? "cursor"
                          : ""
                          }`}
                        onClick={() => {
                          if (
                            !noRecords &&
                            incomeStatus?.status?.calcReady == true
                          )
                            setCalculationSheetModal(true);
                        }}
                      >
                        <svg
                          width="18"
                          height="23"
                          viewBox="0 0 18 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.5139 22.9003H1.82395C1.46534 22.8419 1.12396 22.7053 0.82395 22.5003C0.551247 22.2896 0.334038 22.0155 0.191153 21.7018C0.0482682 21.3882 -0.0159915 21.0444 0.00394313 20.7003C0.00394313 14.5403 0.00394313 8.37365 0.00394313 2.20031C-0.00131438 2.13375 -0.00131438 2.06689 0.00394313 2.00033C0.00394313 1.4699 0.214655 0.961188 0.589728 0.586116C0.964801 0.211043 1.47351 0.000330602 2.00394 0.000330602H15.1939C15.6449 -0.00786692 16.0854 0.136593 16.4439 0.410304C16.7098 0.616994 16.9215 0.88517 17.0608 1.19174C17.2002 1.4983 17.263 1.8341 17.2439 2.17031C17.2439 8.35031 17.2439 14.5337 17.2439 20.7203C17.2439 20.8303 17.2439 20.9403 17.2439 21.0503C17.2264 21.303 17.1591 21.5497 17.0458 21.7763C16.9326 22.0028 16.7756 22.2047 16.5839 22.3703C16.281 22.6393 15.9115 22.8223 15.5139 22.9003ZM8.75394 6.53033H14.0939C14.5539 6.53033 14.7539 6.3403 14.7539 5.8803C14.7539 5.4203 14.7539 4.68031 14.7539 4.07031C14.7539 3.62031 14.5539 3.42031 14.1039 3.42031H3.42394C2.96394 3.42031 2.76394 3.63032 2.76394 4.08032C2.76394 4.53032 2.76394 5.26033 2.76394 5.84033C2.76394 6.42033 2.94395 6.54031 3.46395 6.54031L8.75394 6.53033ZM11.0539 19.9303H14.0539C14.153 19.9398 14.253 19.9271 14.3466 19.8932C14.4402 19.8592 14.525 19.8048 14.5949 19.7339C14.6648 19.663 14.7181 19.5775 14.7508 19.4835C14.7835 19.3894 14.7948 19.2893 14.7839 19.1903C14.7839 18.9703 14.7839 18.7503 14.7839 18.5203C14.7839 17.9103 14.5539 17.6703 13.9439 17.6703H8.08395C7.99206 17.6702 7.90112 17.6888 7.8166 17.7248C7.73208 17.7608 7.65574 17.8136 7.59218 17.88C7.52863 17.9463 7.47918 18.0249 7.44683 18.1109C7.41448 18.1969 7.39988 18.2885 7.40394 18.3803C7.40394 18.6203 7.40394 18.8703 7.40394 19.1103C7.40394 19.6803 7.64394 19.9303 8.22394 19.9303H11.0539ZM3.87394 19.9303H4.50394C4.59364 19.9304 4.68243 19.9124 4.76505 19.8775C4.84767 19.8426 4.92243 19.7914 4.98492 19.7271C5.0474 19.6627 5.09634 19.5865 5.12881 19.5029C5.16128 19.4193 5.17662 19.33 5.17394 19.2403C5.17394 18.947 5.17394 18.657 5.17394 18.3703C5.17805 18.2803 5.16369 18.1904 5.13174 18.1062C5.09978 18.0219 5.05091 17.9451 4.98813 17.8805C4.92536 17.8158 4.85002 17.7647 4.76675 17.7303C4.68347 17.6959 4.59404 17.6789 4.50394 17.6803C4.08394 17.6803 3.66394 17.6803 3.25394 17.6803C3.16344 17.6774 3.07332 17.6933 2.98936 17.7272C2.90539 17.7611 2.82944 17.8122 2.76636 17.8772C2.70329 17.9421 2.65447 18.0195 2.62305 18.1045C2.59164 18.1894 2.57832 18.28 2.58395 18.3703C2.58395 18.6503 2.58395 18.9303 2.58395 19.2203C2.57674 19.3137 2.58949 19.4075 2.62134 19.4956C2.6532 19.5836 2.70342 19.6639 2.76868 19.7311C2.83395 19.7982 2.91275 19.8507 2.99987 19.8851C3.08698 19.9194 3.18041 19.9349 3.27395 19.9303H3.87394ZM8.67394 13.3603H8.02395C7.93774 13.3603 7.85238 13.3774 7.77286 13.4107C7.69334 13.444 7.62124 13.4928 7.56075 13.5542C7.50026 13.6156 7.45259 13.6885 7.42052 13.7685C7.38845 13.8485 7.37261 13.9341 7.37394 14.0203C7.37394 14.3303 7.37394 14.6403 7.37394 14.9603C7.37656 15.1336 7.44727 15.2989 7.57076 15.4206C7.69425 15.5422 7.86062 15.6103 8.03394 15.6103H9.31394C9.48384 15.6078 9.64623 15.5399 9.76731 15.4207C9.88839 15.3015 9.95882 15.1402 9.96395 14.9703C9.96395 14.6403 9.96395 14.3103 9.96395 13.9703C9.95894 13.8075 9.892 13.6527 9.7768 13.5375C9.6616 13.4223 9.50679 13.3553 9.34394 13.3503C9.12394 13.3503 8.90394 13.3603 8.67394 13.3603ZM8.67394 11.2803H9.34394C9.51194 11.2777 9.67218 11.2091 9.79005 11.0894C9.90792 10.9696 9.97397 10.8083 9.97394 10.6403C9.97394 10.3203 9.97394 9.98698 9.97394 9.64032C9.97394 9.47058 9.90651 9.30779 9.78649 9.18777C9.66647 9.06775 9.50368 9.00033 9.33395 9.00033H8.03394C7.86405 9.00283 7.70166 9.07075 7.58059 9.18997C7.45951 9.30918 7.38908 9.47048 7.38395 9.64032C7.38395 9.96031 7.38395 10.2936 7.38395 10.6403C7.38387 10.8066 7.44854 10.9665 7.56428 11.0859C7.68001 11.2054 7.8377 11.2751 8.00394 11.2803H8.67394ZM3.88395 15.6103H4.49395C4.5836 15.613 4.67288 15.5977 4.75649 15.5652C4.8401 15.5327 4.91634 15.4838 4.98069 15.4213C5.04504 15.3588 5.09618 15.284 5.13109 15.2014C5.16601 15.1188 5.18399 15.03 5.18395 14.9403C5.18395 14.6303 5.18395 14.3303 5.18395 14.0203C5.18527 13.9363 5.17002 13.8528 5.13907 13.7746C5.10813 13.6965 5.0621 13.6252 5.00359 13.5648C4.94509 13.5045 4.87527 13.4562 4.79812 13.4228C4.72097 13.3895 4.638 13.3716 4.55395 13.3703C4.10395 13.3703 3.66395 13.3703 3.21395 13.3703C3.0486 13.373 2.89092 13.4405 2.77492 13.5583C2.65893 13.6762 2.59392 13.835 2.59394 14.0003C2.59394 14.3203 2.59394 14.6303 2.59394 14.9403C2.59259 15.0287 2.60901 15.1164 2.6422 15.1983C2.6754 15.2802 2.72469 15.3546 2.78718 15.4171C2.84966 15.4796 2.92406 15.5289 3.00596 15.5621C3.08786 15.5953 3.17558 15.6117 3.26394 15.6103H3.88395ZM13.4839 15.6103H14.0939C14.1832 15.6117 14.2717 15.595 14.3543 15.5612C14.4369 15.5274 14.5118 15.4772 14.5744 15.4136C14.637 15.3501 14.6861 15.2745 14.7187 15.1914C14.7513 15.1083 14.7667 15.0195 14.7639 14.9303C14.7639 14.637 14.7639 14.347 14.7639 14.0603C14.7712 13.9683 14.7587 13.8757 14.7273 13.7889C14.696 13.702 14.6465 13.6228 14.5822 13.5566C14.5178 13.4904 14.4401 13.4386 14.3542 13.4048C14.2683 13.3709 14.1762 13.3558 14.0839 13.3603H12.8539C12.7656 13.3576 12.6776 13.3727 12.5952 13.4047C12.5128 13.4367 12.4377 13.4849 12.3743 13.5464C12.3109 13.608 12.2604 13.6816 12.226 13.763C12.1916 13.8444 12.1739 13.9319 12.1739 14.0203C12.1739 14.327 12.1739 14.637 12.1739 14.9503C12.1752 15.0392 12.1942 15.1269 12.2297 15.2083C12.2652 15.2898 12.3165 15.3634 12.3808 15.4248C12.445 15.4862 12.5208 15.5342 12.6037 15.5661C12.6867 15.5979 12.7751 15.613 12.8639 15.6103H13.4839ZM3.89394 9.04031H3.24395C3.07156 9.04031 2.90622 9.10881 2.78432 9.23071C2.66242 9.35261 2.59394 9.51794 2.59394 9.69033C2.59394 10.0003 2.59394 10.3103 2.59394 10.6103C2.58975 10.6986 2.60389 10.7867 2.63544 10.8692C2.667 10.9517 2.71529 11.0268 2.77729 11.0898C2.83929 11.1527 2.91364 11.2022 2.99567 11.235C3.07771 11.2677 3.16564 11.2832 3.25394 11.2803H4.52395C4.61014 11.2817 4.69574 11.2658 4.77576 11.2337C4.85578 11.2017 4.92862 11.154 4.99004 11.0935C5.05146 11.033 5.10023 10.9609 5.13352 10.8814C5.16681 10.8019 5.18396 10.7165 5.18395 10.6303C5.18395 10.3203 5.18395 10.0003 5.18395 9.69033C5.1827 9.60192 5.1637 9.51464 5.12807 9.43371C5.09245 9.35279 5.04093 9.27986 4.97657 9.21923C4.91221 9.1586 4.83632 9.11151 4.75341 9.08078C4.6705 9.05004 4.58228 9.03628 4.49395 9.04031H3.89394ZM13.4539 11.2803H14.1039C14.1922 11.2832 14.2802 11.2677 14.3622 11.235C14.4443 11.2022 14.5186 11.1527 14.5806 11.0898C14.6426 11.0268 14.6909 10.9517 14.7224 10.8692C14.754 10.7867 14.7681 10.6986 14.7639 10.6103C14.7639 10.3203 14.7639 10.0203 14.7639 9.72033C14.7683 9.62901 14.7534 9.53777 14.7202 9.4526C14.6869 9.36744 14.6361 9.29025 14.5709 9.22607C14.5058 9.16189 14.4279 9.11217 14.3423 9.08016C14.2566 9.04816 14.1652 9.03458 14.074 9.04031H12.8639C12.7756 9.03628 12.6874 9.05004 12.6045 9.08078C12.5216 9.11151 12.4457 9.1586 12.3813 9.21923C12.317 9.27986 12.2654 9.35279 12.2298 9.43371C12.1942 9.51464 12.1752 9.60192 12.1739 9.69033C12.1739 10.0103 12.1739 10.3303 12.1739 10.6903C12.1752 10.7744 12.1931 10.8573 12.2265 10.9345C12.2598 11.0116 12.3081 11.0814 12.3684 11.1399C12.4288 11.1985 12.5001 11.2445 12.5783 11.2754C12.6564 11.3064 12.7399 11.3216 12.824 11.3203L13.4539 11.2803Z"
                            fill="#848484"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="icon-wrap-title d-flex justify-content-center text-center">
                      {" "}
                      <span
                        style={{
                          cursor:
                            incomeStatus?.status?.calcReady === true
                              ? "pointer"
                              : "default",
                        }}
                        onClick={() => {
                          if (
                            !noRecords &&
                            incomeStatus?.status?.calcReady == true
                          )
                            setCalculationSheetModal(true);
                        }}
                      >
                        {" "}
                        Income Calc
                        <br /> Sheet{" "}
                      </span>
                    </div>
                  </div>
                </Col>
              </div>
            </div>
            <div className="income-doc-wrap income-box dowload-income-box flex-fill">
              <h3 className="d-block text-center">Downloads</h3>
              <div className="income-icon-wrap d-flex">
                <Col xs="6">
                  <div className="download-option-cell">
                    <div className="icon-wrap d-flex justify-content-center">
                      <span className="icon-btn">
                        <svg
                          width="23"
                          height="23"
                          viewBox="0 0 23 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="23"
                            height="23"
                            rx="11.5"
                            fill="#848484"
                          />
                          <path
                            d="M12.2208 14.0597L12.4217 13.8673C13.3172 12.9802 14.2042 12.0847 15.0997 11.206C15.23 11.0738 15.391 10.9761 15.5683 10.9215C15.716 10.8903 15.8698 10.9086 16.006 10.9737C16.1421 11.0388 16.253 11.1469 16.3215 11.2813C16.3962 11.4133 16.4267 11.5657 16.4086 11.7162C16.3905 11.8668 16.3248 12.0076 16.2211 12.1182L16.0956 12.2521L12.2376 16.1101C12.1436 16.2115 12.0297 16.2924 11.9029 16.3477C11.7762 16.403 11.6394 16.4316 11.5011 16.4316C11.3629 16.4316 11.2261 16.403 11.0994 16.3477C10.9726 16.2924 10.8587 16.2115 10.7647 16.1101C9.46753 14.8129 8.17875 13.5158 6.87322 12.2186C6.76398 12.1263 6.68263 12.0053 6.63828 11.8693C6.59394 11.7333 6.58834 11.5877 6.62214 11.4487C6.65231 11.3365 6.70952 11.2334 6.78874 11.1484C6.86796 11.0634 6.96678 10.9991 7.07659 10.9611C7.1864 10.9231 7.30386 10.9126 7.41867 10.9305C7.53348 10.9484 7.64216 10.9941 7.7352 11.0637L7.93604 11.2395L10.5722 13.8756C10.6381 13.9465 10.708 14.0135 10.7814 14.0765V6.41907C10.8005 6.24264 10.8842 6.07949 11.0162 5.96096C11.1483 5.84242 11.3195 5.77686 11.497 5.77686C11.6744 5.77686 11.8456 5.84242 11.9777 5.96096C12.1097 6.07949 12.1934 6.24264 12.2125 6.41907C12.2125 6.50276 12.2125 6.58645 12.2125 6.67014V14.0597H12.2208Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="icon-wrap-title d-flex justify-content-center text-center">
                      Download <br /> Options
                    </div>
                  </div>
                </Col>
                <Col xs="6">
                  <div
                    className={`${incomeStatus?.status?.calcReady == true
                      ? "active-cell"
                      : ""
                      } prev-calc-cell`}
                  >
                    <div className="icon-wrap d-flex justify-content-center">
                      <span
                        className={`icon-btn  ${incomeStatus?.status?.calcReady == true
                          ? "cursor"
                          : ""
                          } `}
                        onClick={() => {
                          if (
                            !noRecords &&
                            incomeStatus?.status?.calcReady == true
                          )
                            setCalculationSheetModal(true);
                        }}
                      >
                        <svg
                          width="23"
                          height="23"
                          viewBox="0 0 23 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="23"
                            height="23"
                            rx="11.5"
                            fill="#848484"
                          />
                          <path
                            d="M11.8802 10.097C12.2162 9.85705 12.4802 9.65305 12.7562 9.43705C14.0882 8.42905 15.4082 7.43305 16.7282 6.41305C16.8299 6.31145 16.9602 6.24326 17.1017 6.21754C17.2432 6.19181 17.3891 6.20978 17.5202 6.26905C17.6432 6.33462 17.7428 6.43685 17.8051 6.56155C17.8675 6.68626 17.8895 6.82727 17.8682 6.96505V15.797C17.8967 15.9363 17.8786 16.0811 17.8167 16.2091C17.7548 16.3371 17.6525 16.4412 17.5256 16.5054C17.3987 16.5695 17.2542 16.5901 17.1145 16.564C16.9747 16.5379 16.8474 16.4666 16.7522 16.361L12.1442 12.857C12.0611 12.7866 11.9728 12.7224 11.8802 12.665V15.785C11.9053 15.9234 11.8863 16.0661 11.8261 16.1931C11.7658 16.3201 11.6672 16.425 11.5442 16.493C11.4128 16.5507 11.2673 16.5677 11.1262 16.5421C10.9851 16.5164 10.8548 16.4492 10.7522 16.349L4.96818 11.945C4.86504 11.8913 4.77862 11.8103 4.71831 11.7109C4.658 11.6114 4.6261 11.4973 4.6261 11.3811C4.6261 11.2648 4.658 11.1507 4.71831 11.0512C4.77862 10.9518 4.86504 10.8708 4.96818 10.817C6.91218 9.33705 8.85218 7.85705 10.7882 6.37705C10.8857 6.28877 11.0067 6.23049 11.1365 6.20921C11.2663 6.18792 11.3995 6.20453 11.5202 6.25705C11.6423 6.31807 11.7425 6.41546 11.807 6.53581C11.8715 6.65617 11.8971 6.79356 11.8802 6.92905V10.097ZM12.3002 11.3811L16.5842 14.645V8.11705L12.3002 11.3811ZM6.30016 11.3811L10.5842 14.645V8.11705L6.30016 11.3811Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="icon-wrap-title d-flex justify-content-center text-center">
                      <span
                        style={{
                          cursor:
                            incomeStatus?.status?.calcReady === true
                              ? "pointer"
                              : "default",
                        }}
                        onClick={() => {
                          if (
                            !noRecords &&
                            incomeStatus?.status?.calcReady === true
                          )
                            setCalculationSheetModal(true);
                        }}
                      >
                        Previous
                        <br />
                        Calculations
                      </span>
                    </div>
                  </div>
                </Col>
              </div>
            </div>
            <div className="links-wrap income-box flex-md-fill">
              <h3 className="d-block text-center">Links</h3>
              <div className="income-icon-wrap d-flex">
                <Col xs="12">
                  <div>
                    <div className="icon-wrap d-flex justify-content-center">
                      <img
                        onClick={() => {
                          handleClick1();
                          setHeading("ID.me PDF Instructions");
                        }}
                        role="button"
                        src={IdLogo}
                        alt="IdLogo"
                      />
                    </div>
                    <div className="icon-wrap-title d-flex justify-content-center text-center">
                      <span
                        onClick={() => {
                          handleClick1();
                          setHeading("ID.me PDF Instructions");
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {" "}
                        ID.me PDF
                        <br /> Instructions{" "}
                      </span>
                    </div>
                  </div>
                  <Modal isOpen={calculationSheetModal} backdrop="static">
                    <ModalHeader>
                      Income Calc Sheet
                      <button
                        onClick={() => setCalculationSheetModal(false)}
                        type="button"
                        class="btn-close"
                        aria-label="Close"
                      ></button>
                    </ModalHeader>
                    <ModalBody>
                      <div className="download-popup">
                        <Row className="text-center align-items-center">
                          <Col>
                            <p className="f-icons">
                              <span className="excel-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="50"
                                  height="50"
                                  viewBox="0 0 50 50"
                                >
                                  <path d="M28.813.031l-28 5.313c-.473.09-.813.52-.813 1v37.312c0 .48.34.91.813 1l28 5.313c.062.011.125.031.187.031.23 0 .445-.07.625-.219.23-.191.375-.484.375-.781V1c0-.297-.145-.59-.375-.781-.23-.192-.52-.242-.813-.188zM32 6v7h2v2h-2v5h2v2h-2v5h2v2h-2v6h2v2h-2v7h15c1.102 0 2-.898 2-2V8c0-1.102-.898-2-2-2zm4 7h8v2h-8zM6.687 15.688h5.125L14.5 21.28c.21.442.398.985.563 1.594h.03c.106-.363.31-.934.595-1.656l2.968-5.532h4.688l-5.594 9.25 5.75 9.438h-4.969l-3.25-6.094c-.12-.226-.246-.644-.375-1.25h-.031c-.063.285-.21.73-.438 1.313l-3.25 6.031h-5l5.97-9.344zM36 20h8v2h-8zm0 7h8v2h-8zm0 8h8v2h-8z"></path>
                                </svg>
                              </span>
                            </p>
                          </Col>
                          <Col>
                            <Button
                              color="primary"
                              onClick={handleClick}
                              className="download-btn"
                            >
                              <FontAwesomeIcon icon={faDownload} />
                              Download
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </ModalBody>
                  </Modal>
                </Col>
              </div>
            </div>
          </div>
          <div className="income-form-row d-flex">
            <div className="inner flex-fill d-flex align-items-center ">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "form-view",
                    })}
                    onClick={(e) => {
                      toggle_tabs("form-view");
                    }}
                    style={{
                      color: activeTab === "form-view" ? "blue" : "gray",
                    }}
                  >
                    View
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "audit-log",
                    })}
                    onClick={(e) => {
                      if (!pendingIrsIncomeLoanNumber)
                        toggle_tabs("audit-log");
                    }}
                    style={{
                      color: activeTab === "audit-log" ? "blue" : "gray",
                    }}
                  >
                    Audit Log
                  </NavLink>
                </NavItem>
              </Nav>
              <div className={`pdf-filter-btns d-inline-flex align-items-center justify-content-end`}>

                {isQCPerson && irsDetail?.quality_control ? <div className="btn-col ms-auto d-inline-flex align-items-center">
                  <span style={{ margin: "0px 10px" }}>QC Review</span>
                  {/* {console.log('button active link -->', activeLink)} */}
                  <Button className={`btn ${qaActiveLink !== 1 ? 'btn-outline-success' : 'btn-success'}`} onClick={() => qaStatus(1)} color='link' data-toggle="tooltip" data-placement="top" title={qaActiveLink == 1 ? "PASSED" : "PASS"}>
                    PASS
                  </Button>
                  <Button className={`btn ${qaActiveLink !== 2 ? 'btn-outline-danger' : 'btn-danger'}`} onClick={() => qaStatus(2)} color='link' data-toggle="tooltip" data-placement="top" title={qaActiveLink == 2 ? "FAILED" : "FAIL"}>
                    FAIL
                  </Button>
                </div> : null}
              </div>
            </div>
            <div className="from-group">
              <select className="form-control form-select">
                {taxFormsListing.map((item, i) => {
                  return <option>{item?.name}</option>;
                })}
              </select>
            </div>
          </div>
          {loader && (
            <LoaderUI message={false} FullWindow={false} inContainer={true} />
          )}
          <TabContent activeTab={activeTab} style={{ height: "100%" }}>
            {activeTab == "form-view" ? (
              <TabPane tabId="form-view" style={{ height: "100%" }}>
                {!noRecords && (irsDetail || pendingIrsIncomeDetail) && pdfFileURL && (
                  <>
                    <div className="d-flex align-items-center loan-number-title">

                      {irsDetail && (
                        <div className="left-col">
                          {irsDetail?.employer_name} - {irsDetail?.taxpayer_name} -  Loan #{" "}
                          {irsDetail?.loan_number}
                        </div>

                      )}
                      {pendingIrsIncomeDetail && (
                        <div className="left-col">
                          {'Pending'} -  Loan #{" "}
                          {pendingIrsIncomeDetail?.loanNumber}
                        </div>

                      )}

                      <div className="right-col ms-auto">
                        <Button
                          color="link"
                          onClick={() => _pdfDownload()}
                          className="btn-outline-secondary download-btn"
                        >
                          <FontAwesomeIcon icon={faDownload} />
                          Download PDF
                        </Button>
                      </div>
                    </div>
                    {pdfFileURL ? (
                      <iframe
                        src={`${pdfFileURL}#view=FitH`}
                        type="application/pdf"
                        height="100%"
                        width="100%"
                      ></iframe>
                    ) : (
                      ""
                    )}
                  </>
                )}
                {noRecords && <NoItem />}
                {internalError && (
                  <ErrorMessage className="h-auto" data={internalError} />
                )}
              </TabPane>
            ) : null}
            {activeTab == "audit-log" && activeId ? (
              <TabPane
                tabId="audit-log"
                className="audit-log-list position-relative"
              >
                {!noRecords && (
                  <DocumentLog incomeData={irsDetail} activeId={activeId} />
                )}
              </TabPane>
            ) : null}
          </TabContent>
        </div>

        {!noRecords && <div
          className={`right-col  sidebar-editor-col d-flex flex-column pt-0 ${editorVisible ? "active" : ""
            }`}
        >
          <div className="loan-doc-info-wrapper">
            {Object.keys(incomeDocList).length !== 0 && (
              <div className="incomesheet-btn-rw">
                <Button
                  color="primary"
                  disabled={(!incomeStatus?.status?.calcReady) || (incomeStatus?.status?.calcReady == true && incomeStatus?.status?.reviewRequired == true && !underwriter)}
                  onClick={toggleModal}
                >
                  Send Income Worksheet to Loan Contact(s)
                </Button>
              </div>
            )}
            {Object.keys(incomeDocList).length !== 0 && !noRecords && irsDetail && pdfFileURL && (
              <div className="incomesheet-btn-rw">
                <Button
                  color="danger"
                  disabled={log == "Sent Income Worksheet to Loan Contacts"}
                  onClick={() => {
                    setIsUnableToValidateOpen(true);
                    setDisabledUnableToDocumentFields(false);
                  }}
                >
                  Unable to Calculate Income
                </Button>

              </div>
            )}

            {
              Object.keys(incomeDocList).length !== 0 &&
              incomeDocList?.incomeDocs?.length > 0 &&
              <div className="incomesheet-btn-rw">
                <Button
                  color='success'
                  onClick={markAscomplete}
                >
                  Mark Complete
                </Button>

              </div>}
            {Object.keys(incomeDocList).length !== 0 &&
              incomeDocList?.incomeDocs?.length > 0 && (
                <div className="loan-doc-info income-docs">
                  <div className="head">Income Documents Provided</div>
                  <div className="inner">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Form</th>
                          <th>Year</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                    <tbody>
                      {incomeDocList?.incomeDocs?.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              {item?.documentId ? (
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    openDocumentDirectlyInNewTab(item.documentId);
                                  }}
                                >
                                  {item.formName}
                                </a>
                              ) : (
                                item.formName
                              )}
                            </td>

                            <td>{item?.formYear}</td>
                            <td>{item?.formStatus}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                    </table>
                  </div>
                </div>
              )}

            {pendingIrsIncomeLoanNumber && pendingIrsIncomeDetail  && (
              <div className="loan-doc-info income-docs">
                <div className="head">Pending Income Documents</div>
                <div className="inner">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Form</th>
                        <th>Year</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendingIrsIncomeDetail?.pendingIncomeDocs?.map((item, index) => {
                        return (
                          <tr>
                            <td>{item?.formName}</td>
                            <td>{item?.formYear}</td>
                            <td>{item?.formStatus}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}




            {Object.keys(incomeStatus).length !== 0 &&
              incomeStatus?.status?.calcReady == false && (
                <div className="loan-doc-info">
                  <div className="head">
                    Additional Income Documents Required
                  </div>
                  {/* <div className="inner">
                    <ul className="doc-list mb-0">
                      {incomeStatus?.unmetDependencies?.map((item, index) => {
                        return <li>{item?.detailedErrorMessage}</li>;
                      })}
                    </ul>
                  </div> */}
                  <div className="inner">
                    {Object.keys(groupedMessages).map((category) => (
                      <div key={category}>
                        <b>{category === 'withoutcategory' ? 'Without Category' : category}</b>
                        <ul className="doc-list mb-0">
                          {groupedMessages[category].map((message, index) => (
                            <li key={index}>{message}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            {!(irsDetail?.unable_to_calculate_income || irsDetail?.sent_to_los_status == 'Completed') ? Object.keys(incomeStatus).length !== 0 &&
              incomeStatus?.status?.calcReady == true && incomeStatus?.status?.reviewRequired == true ? (
              irsDetail?.recalculation === true ? (
                <div className="ready-msg text-warning">
                  Recalculation Ready for Review
                </div>
              ) : (
                <div className="ready-msg text-warning">
                  Ready for Underwriter Review
                </div>
              )
            ) : incomeStatus?.status?.calcReady == true && (

              irsDetail?.recalculation === true ? (
                <div className="ready-msg text-success">
                  Recalculation Ready to Send
                </div>
              ) : (
                <div className="ready-msg text-success">
                  Ready to Calculate Income
                </div>
              )


            ) : null}


            <br />


            {log == "Sent Income Worksheet to Loan Contacts" && Object.keys(incomeStatus).length !== 0 && (
              <span
                style={{ fontWeight: "bold" }}
                className="ready-msg text-success"
              >
                {" "}
                {time && loader == false
                  ? "Income Worksheet sent" +
                  " " +
                  moment(time).format("MM/DD/YYYY") +
                  " " +
                  moment(time).format("h:mm A")
                  : null}
              </span>
            )}

            {log == "Unable to Calculate Income" && Object.keys(incomeStatus).length !== 0 &&
              (
                <span
                  style={{ fontWeight: "bold" }}
                  className="ready-msg text-danger"
                >
                  {" "}
                  {time && loader == false
                    ? "Unable to Calculate Income sent" +
                    " " +
                    moment(time).format("MM/DD/YYYY") +
                    " " +
                    moment(time).format("h:mm A")
                    : null}
                </span>
              )}

            <br />


            {incomeStatus?.status?.calcReady == true && incomeStatus?.status?.reviewRequired == true && incomeStatus?.status?.reviewNotes.length !== 0 && (
              <div className="loan-doc-info">
                <div className="head">
                  Reviewer Notes:
                </div>
                <div className="inner">
                  <ul className="doc-list mb-0">
                    {incomeStatus.status.reviewNotes.map((item, index) => {
                      return <li>{item?.message}</li>;
                    })}
                  </ul>
                </div>
              </div>
            )}



          </div>
          <UnableToIncomeAnalyzer
            title={"Reason Income Cannot be Calculated"}
            disabledForm={disabledUnableToDocumentFields}
            showModel={isUnableToValidateOpen}
            _toggle={() => setIsUnableToValidateOpen(false)}
            currentFile={incomeStatus}
            _saveUnableToIncomeAnalyzerJsonData={(data) => _saveUnableToIncomeAnalyzerJsonData(data)}
          />
        </div>}
        <Modal
          isOpen={modal}
          toggle={toggleModal}
          className="role-based-login-modal"
          size="lg"
        >
          <Formik
            initialValues={initValues}
            enableReinitialize
            onSubmit={sendLoans}
          >
            {(formik) => (
              <Form>
                <ModalHeader>
                  Select Loan Contacts
                  <Button
                    color="link"
                    onClick={toggleModal}
                    className="close-btn"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="34"
                      height="34"
                      viewBox="0 0 34 34"
                    >
                      <g
                        data-name="Group 651"
                        transform="translate(-1535 -134)"
                      >
                        <g
                          fill="#fff"
                          stroke="#000"
                          strokeWidth="2"
                          data-name="Ellipse 30"
                          opacity="0.3"
                          transform="translate(1535 134)"
                        >
                          <circle cx="17" cy="17" r="17" stroke="none"></circle>
                          <circle cx="17" cy="17" r="16" fill="none"></circle>
                        </g>
                        <path
                          d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                          data-name="Icon ionic-ios-close"
                          opacity="0.3"
                          transform="translate(1534.289 132.789)"
                        ></path>
                      </g>
                    </svg>
                  </Button>
                </ModalHeader>
                <ModalBody>
                  <div className="loan-contacts-list">
                    {msg && <span className="txt">{msg}</span>}
                    <div className="list-items d-flex flex-wrap">
                      {contacts &&
                        contacts.map((contact, i) => {
                          return (
                            <>
                              <Label key={i} className="">
                                <Input
                                  type="checkbox"
                                  name={`notify_${i}`}
                                  // defaultChecked={notify ? true : false}
                                  checked={formik.values[`notify_${i}`]}
                                  // disabled={disabledForm}
                                  onChange={(e) => {
                                    if (!e.target.checked) {
                                      formik.setFieldValue("notify", false);
                                      formik.setFieldValue(
                                        `notify_${i}`,
                                        false
                                      );
                                      setContactList((prevValue) =>
                                        prevValue.filter(
                                          (c) => c.email !== contact.email
                                        )
                                      );
                                    } else {
                                      formik.setFieldValue(
                                        `notify_${i}`,
                                        e.target.checked
                                      );
                                      setContactList((prevValue) => [
                                        ...prevValue,
                                        { email: contact.email },
                                      ]);
                                      if (
                                        contacts.length ===
                                        contactList.length + 1
                                      ) {
                                        formik.setFieldValue("notify", true);
                                      }
                                    }
                                  }}
                                />
                                <span className="txt">
                                  {contact.role} : {contact.email}
                                </span>
                              </Label>
                            </>
                          );
                        })}
                    </div>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Label className="notify-cell">
                    <Input
                      type="checkbox"
                      name="notify"
                      defaultChecked={notify ? true : false}
                      checked={formik.values[`notify`]}
                      disabled={msg ? true : false}
                      onChange={(e) => {
                        formik.setFieldValue("notify", e.target.checked);
                        if (e.target.checked) {
                          contacts.forEach((contact, i) => {
                            formik.setFieldValue(`notify_${i}`, true);
                            setContactList((prevValue) => [
                              ...prevValue,
                              { email: contact.email },
                            ]);
                          });
                        } else {
                          contacts.forEach((contact, i) => {
                            formik.setFieldValue(`notify_${i}`, false);
                            setContactList([]);
                          });
                        }
                      }}
                    />
                    <span className="txt" style={{ marginLeft: "4px" }}>
                      {"Notify all contacts"}
                    </span>
                  </Label>
                  <Button
                    color="secondary"
                    type="submit"
                    disabled={msg ? true : false}
                  >
                    Send Income Worksheet to Loan Contact
                  </Button>
                </ModalFooter>
              </Form>
            )}
          </Formik>
        </Modal>
        <Modal isOpen={modalOpen}>
          <ModalHeader>{qaActiveLink == 1 ? "" : "Enter Reason for Failure"}
            <Button color='link' onClick={toggleModal2}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                viewBox="0 0 34 34"
              >
                <g data-name="Group 651" transform="translate(-1535 -134)">
                  <g
                    fill="#fff"
                    stroke="#000"
                    strokeWidth="2"
                    data-name="Ellipse 30"
                    opacity="0.3"
                    transform="translate(1535 134)"
                  >
                    <circle cx="17" cy="17" r="17" stroke="none"></circle>
                    <circle cx="17" cy="17" r="16" fill="none"></circle>
                  </g>
                  <path
                    d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                    data-name="Icon ionic-ios-close"
                    opacity="0.3"
                    transform="translate(1534.289 132.789)"
                  ></path>
                </g>
              </svg>
            </Button>
          </ModalHeader>
          <ModalBody>
            {qaActiveLink == 1 ? <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Does this Pass QC Review?</span> : <Input
              type="text"
              value={failureReason}
              onChange={handleInputChange}
              placeholder="Enter reason for failure"
              className='bold-placeholder'
            />}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>{' '}
            <Button color="secondary" onClick={toggleModal2}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default IncomeAnalyzer;
